import {ToolbarIcons} from '@priority-software/priority-style-react';
import {TIconType} from '../components/SideBar/types';
import {getUuid4} from '../../../utils/getUuid4';
import {typeComponents} from '../components/SideBar/constants';
import {texts} from '../texts';

const createIconObject = (iconName: ToolbarIcons, type: TIconType, content: string) => ({
    iconName,
    id: getUuid4(),
    type,
    content
});

export const icons = [
    createIconObject(
        ToolbarIcons.toolbarCode,
        typeComponents.PERSONALIZE,
        texts.add_dynamic_value_tooltip
    ),
    createIconObject(ToolbarIcons.toolbarImage, typeComponents.IMAGE, texts.add_an_image),
    createIconObject(
        ToolbarIcons.toolbarAddLink,
        typeComponents.HYPERLINK,
        texts.add_hyperlink_tooltip
    )
];
